import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { PostContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({providedIn: 'root'})
export class PostService extends BaseApiTemplateService<PostContainer> {
  constructor(private http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-drive-links';
    this.httpClient = http;
  }
}